export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M6 0a2 2 0 00-2 2v2H1a1 1 0 000 2h1v9a1 1 0 001 1h10a1 1 0 001-1V6h1a1 1 0 000-2h-3V2a2 2 0 00-2-2zm4 4V2H6v2zM4 6v8h8V6z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};